import styled from 'styled-components';

export const GreenDot = styled.div`
  width: 10px;
  height: 10px;
  background-color: var(--green);
  border-radius: 100%;
  margin-right: 15px;
`;
